import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/illus-home.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "container bg-white" }
const _hoisted_3 = { class: "flex justify-between px-4 py-4 bg-white" }
const _hoisted_4 = { class: "grid lg:grid-cols-3 grid-cols-1 lg:divide-x divide-gray-100 bg-white p-3" }
const _hoisted_5 = { class: "flex flex-row space-x-3 mt-1" }
const _hoisted_6 = { class: "flex bg-primary w-7 h-7 p-1 text-white items-center justify-center rounded-full" }
const _hoisted_7 = { class: "text-gray 700 font-semibold text-medium" }
const _hoisted_8 = { clas: "" }
const _hoisted_9 = { class: "font-sm text-gray-600 py-3" }
const _hoisted_10 = { class: "bg-background" }
const _hoisted_11 = { class: "container flex flex-col" }
const _hoisted_12 = { class: "card-main mb-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "flex flew-row w-full justify-center py-5 mb-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "px-5 py-2 rounded-full bg-primary-light text-center w-full" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-base font-semibold" }, " You can not add a code challenge without the Challenge ")
  ])
], -1)
const _hoisted_14 = { class: "container" }
const _hoisted_15 = { class: "flex flew-col justify-center space-x-5" }
const _hoisted_16 = { class: "w-full flex-row mt-6" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "" }, [
  /*#__PURE__*/_createTextVNode("Title "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-orange-400" }, "(Required)")
], -1)
const _hoisted_18 = { class: "w-full flex-row mt-6" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "" }, [
  /*#__PURE__*/_createTextVNode("URL "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-orange-400" }, "(Required)")
], -1)
const _hoisted_20 = { class: "bg-background" }
const _hoisted_21 = { class: "container flex flex-col" }
const _hoisted_22 = { class: "card-main my-6" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-semibold" }, "Configuration", -1)
const _hoisted_24 = { class: "flex flex-row items-start justify-between mt-4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-4/5" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "AI Talent Matching"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 mt-2" }, " Turning on AI Talent Matching will allow us to automatically add candidates that match the required skills to your job. ")
], -1)
const _hoisted_26 = { class: "flex justify-end" }
const _hoisted_27 = { class: "flex flex-row items-start justify-between mt-4" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-4/5" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Managed job"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 mt-2" }, " Managed jobs are human and AI assisted jobs. If you set this job as a managed job, our HR experts will assist you with candidate sourcing and screening. "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-gray-500" }, " Note: Each managed job is per month ")
], -1)
const _hoisted_29 = { class: "flex justify-end" }
const _hoisted_30 = { class: "flex flex-row items-start justify-between mt-4" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-4/5" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Confidential Job"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 mt-2" }, " Marking your job as confidential delists your job from your careers page and will be published as a confidential job on Search Engine. "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-gray-500" }, " This action can't be undone. ")
], -1)
const _hoisted_32 = { class: "flex justify-end" }
const _hoisted_33 = {
  key: 0,
  class: "flex flex-col items-start justify-between mt-4"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Publishing date", -1)
const _hoisted_35 = { class: "text-gray-500 mt-2" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("Select a date to appear as the job publishing date on all posting of the platform. ")
const _hoisted_37 = { class: "font-semibold text-gray-500 block" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Current date: ")
const _hoisted_39 = { class: "italic text-primary" }
const _hoisted_40 = { class: "mt-3" }
const _hoisted_41 = { class: "py-8 mb-10 w-full card-main" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-lg" }, "Job members")
], -1)
const _hoisted_43 = { class: "flex flex-row justify-between space-x-3" }
const _hoisted_44 = { class: "w-5/12" }
const _hoisted_45 = { class: "w-5/12" }
const _hoisted_46 = { class: "w-2/12 flex justify-end" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { class: "flex flex-col justify-between items-center" }
const _hoisted_50 = { class: "w-full whitespace-nowrap mt-12" }
const _hoisted_51 = ["onChange", "value"]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("option", { value: "collaborator" }, "collaborator", -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("option", { value: "responsible" }, "responsible", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("option", { value: "internal" }, "internal", -1)
const _hoisted_55 = [
  _hoisted_52,
  _hoisted_53,
  _hoisted_54
]
const _hoisted_56 = ["onClick"]
const _hoisted_57 = /*#__PURE__*/_createStaticVNode("<span><svg class=\"h-6 w-6 text-red-400\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><polyline points=\"3 6 5 6 21 6\"></polyline><path d=\"M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2\"></path><line x1=\"10\" y1=\"11\" x2=\"10\" y2=\"17\"></line><line x1=\"14\" y1=\"11\" x2=\"14\" y2=\"17\"></line></svg></span>", 1)
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = {
  key: 1,
  class: "bg-gray-100 flex flex-col justify-center items-center p-4 mt-10 rounded-lg"
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "160",
  alt: ""
}, null, -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 mt-6 font-medium" }, "Job members no added", -1)
const _hoisted_62 = [
  _hoisted_60,
  _hoisted_61
]
const _hoisted_63 = { class: "container bg-white" }
const _hoisted_64 = { class: "flex justify-between px-4 py-4" }
const _hoisted_65 = /*#__PURE__*/_createTextVNode(" To activate the AI Talent Matching you must first add some skills. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Button = _resolveComponent("Button")!
  const _component_CreateJobForm = _resolveComponent("CreateJobForm")!
  const _component_JobWorkFlowStep = _resolveComponent("JobWorkFlowStep")!
  const _component_EvaluationJobStep = _resolveComponent("EvaluationJobStep")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_SwitchButton = _resolveComponent("SwitchButton")!
  const _component_SimpleDatePicker = _resolveComponent("SimpleDatePicker")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Header),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Loading, {
          active: _ctx.isLoading,
          "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
          "can-cancel": false,
          loader: "spinner",
          color: "#8908F9",
          width: 100,
          height: 100,
          "is-full-page": false
        }, null, 8, ["active"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _withDirectives(_createVNode(_component_Button, {
              variant: "outlined",
              label: 'Previous',
              onOnClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeStep('prev')))
            }, null, 512), [
              [_vShow, _ctx.step != 1]
            ])
          ]),
          _createElementVNode("div", null, [
            _withDirectives(_createVNode(_component_Button, {
              variant: "outlined",
              label: 'Next',
              onOnClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeStep('next')))
            }, null, 512), [
              [_vShow, _ctx.step != 3]
            ]),
            _withDirectives(_createVNode(_component_Button, {
              variant: "contained",
              label: 'Publish',
              onOnClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.confirmationJobSend('create')))
            }, null, 512), [
              [_vShow, _ctx.step === 3 && !_ctx.$route.params.id]
            ]),
            _withDirectives(_createVNode(_component_Button, {
              variant: "contained",
              label: 'Save',
              onOnClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.confirmationJobSend('edit')))
            }, null, 512), [
              [_vShow, _ctx.step === 3 && _ctx.$route.params.id]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stepStages, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "w-full p-4",
              key: `step-${index}`
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["rounded-lg p-3 h-32 transition-all transition-1000 delay-300 border border-white", {
              'bg-primary-light border-2 border-purple-100 shadow-lg transition-all ease-in-out delay-100 -translate-y-1':
                _ctx.step == item.number,
            }])
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(item.number), 1),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(item.title), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("p", _hoisted_9, _toDisplayString(item.description), 1)
                ])
              ], 2)
            ]))
          }), 128))
        ])
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_component_CreateJobForm, {
          id: "skills_section",
          ref: "formRef",
          onOnPublish: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submitForm(1))),
          onOnDraft: _cache[6] || (_cache[6] = ($event: any) => (_ctx.submitForm(0))),
          onSetRequiredSkills: _ctx.setRequiredSkills,
          onSetNiceToHaveSkills: _ctx.setNiceToHaveSkills,
          jobData: _ctx.newFormValues
        }, null, 8, ["onSetRequiredSkills", "onSetNiceToHaveSkills", "jobData"])
      ], 512), [
        [_vShow, _ctx.step === 1]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_JobWorkFlowStep, {
            onSetChallenge: _ctx.getChallengeStage,
            jobData: _ctx.newFormValues.has_challenge
          }, null, 8, ["onSetChallenge", "jobData"]),
          _createVNode(_component_EvaluationJobStep, {
            onSetEvaluation: _ctx.getEvaluation,
            evaluationData: _ctx.newFormValues
          }, null, 8, ["onSetEvaluation", "evaluationData"]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  (_openBlock(), _createBlock(_component_TextField, {
                    label: "",
                    placeholder: "e.g. Vue",
                    typeInput: "text",
                    name: "title",
                    floatingInput: true,
                    disabled: !_ctx.newFormValues.has_challenge_assigned,
                    modelValue: _ctx.challengeValues.title,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.challengeValues.title) = $event)),
                    key: _ctx.reRenderComponents
                  }, null, 8, ["disabled", "modelValue"]))
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  (_openBlock(), _createBlock(_component_TextField, {
                    label: "",
                    placeholder: "e.g. https://mycodechallenge.com",
                    typeInput: "text",
                    name: "challenge_url",
                    floatingInput: true,
                    disabled: !_ctx.newFormValues.has_challenge_assigned,
                    modelValue: _ctx.challengeValues.challenge_url,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.challengeValues.challenge_url) = $event)),
                    key: _ctx.reRenderComponents
                  }, null, 8, ["disabled", "modelValue"]))
                ])
              ])
            ])
          ])
        ])
      ], 512), [
        [_vShow, _ctx.step === 2]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_SwitchButton, {
                  fieldId: "match_candidates",
                  checked: _ctx.matchCandidate,
                  "onUpdate:checked": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.matchCandidate) = $event))
                }, null, 8, ["checked"])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_SwitchButton, {
                  fieldId: "is_managed",
                  checked: _ctx.isManaged,
                  "onUpdate:checked": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.isManaged) = $event))
                }, null, 8, ["checked"])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_SwitchButton, {
                  fieldId: "is_confidential",
                  checked: _ctx.isConfidential,
                  "onUpdate:checked": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.isConfidential) = $event))
                }, null, 8, ["checked"])
              ])
            ]),
            (_ctx.isManaged && _ctx.isEditing)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _hoisted_34,
                  _createElementVNode("span", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("span", _hoisted_37, [
                      _hoisted_38,
                      _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.getFormatStringDate(_ctx.jobDate)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createVNode(_component_SimpleDatePicker, {
                      placeholder: "New publish date",
                      name: "publish_date",
                      modelValue: _ctx.publish_date,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.publish_date) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_41, [
            _hoisted_42,
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.jobMember,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.jobMember) = $event)),
                    options: _ctx.jobMemebersList,
                    label: "user_name",
                    placeholder: "Select collaborator",
                    reduce: (user) => user
                  }, null, 8, ["modelValue", "options", "reduce"])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.memberRole,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.memberRole) = $event)),
                    options: ['collaborator', 'responsible', 'internal'],
                    label: "user_name",
                    placeholder: "Select role"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("button", {
                    class: "btn-filled-sm flex flex-row items-center justify-between truncate sm:text-base bg-primary rounded-full transition duration-150 ease-in disabled:opacity-50 disabled:cursor-not-allowed",
                    disabled: _ctx.jobMember === '' || _ctx.memberRole === '',
                    onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.addMember && _ctx.addMember(...args)))
                  }, " Add member ", 8, _hoisted_47)
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              (_ctx.jobMembers.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("table", _hoisted_50, [
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobMembers, (member, index) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              class: "focus:outline-none h-16 border-b border-gray-100 rounded",
                              key: index
                            }, [
                              _createElementVNode("td", null, _toDisplayString(member.name), 1),
                              _createElementVNode("td", null, _toDisplayString(member.email), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("select", {
                                  name: "members",
                                  class: "bg-gray-100 py-2 px-4 rounded",
                                  onChange: ($event: any) => (_ctx.onSelectChange($event, index)),
                                  value: member.role
                                }, _hoisted_55, 40, _hoisted_51)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (_ctx.deleteJobMember(index))
                                }, _hoisted_58, 8, _hoisted_56)
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_59, _hoisted_62))
            ])
          ])
        ])
      ], 512), [
        [_vShow, _ctx.step === 3]
      ]),
      _createElementVNode("div", _hoisted_63, [
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", null, [
            _withDirectives(_createVNode(_component_Button, {
              variant: "outlined",
              label: 'Previous',
              onOnClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.changeStep('prev')))
            }, null, 512), [
              [_vShow, _ctx.step != 1]
            ])
          ]),
          _createElementVNode("div", null, [
            _withDirectives(_createVNode(_component_Button, {
              variant: "outlined",
              label: 'Next',
              onOnClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.changeStep('next')))
            }, null, 512), [
              [_vShow, _ctx.step != 3]
            ]),
            _withDirectives(_createVNode(_component_Button, {
              variant: "contained",
              label: 'Publish',
              onOnClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.confirmationJobSend('create')))
            }, null, 512), [
              [_vShow, _ctx.step === 3 && !_ctx.$route.params.id]
            ]),
            _withDirectives(_createVNode(_component_Button, {
              variant: "contained",
              label: 'Save',
              onOnClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.confirmationJobSend('edit')))
            }, null, 512), [
              [_vShow, _ctx.step === 3 && _ctx.$route.params.id]
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_base_modal, { visible: _ctx.showConfirmationModal }, {
      "alert-text": _withCtx(() => [
        _createTextVNode(" When a " + _toDisplayString(_ctx.textHelper) + " is created it will generate cost to the client. ", 1)
      ]),
      actions: _withCtx(() => [
        _createElementVNode("button", {
          class: "btn-outline-sm flex flex-row items-center disabled:opacity-50 justify-between px-4 py-2 text-primary truncate sm:text-base border-2 rounded-full transition duration-150 ease-in",
          onClick: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (_ctx.confirmationModal.tell(false)), ["prevent"]))
        }, " Decline "),
        _createElementVNode("button", {
          class: "btn-filled-sm flex flex-row items-center disabled:opacity-50 justify-between truncate sm:text-base bg-primary rounded-full transition duration-150 ease-in",
          onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (_ctx.confirmationModal.tell(true)), ["prevent"]))
        }, " Confirm ")
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_base_modal, { visible: _ctx.showConfirmationSkillsModal }, {
      "alert-text": _withCtx(() => [
        _hoisted_65
      ]),
      actions: _withCtx(() => [
        _createElementVNode("button", {
          class: "btn-outline-sm flex flex-row items-center disabled:opacity-50 justify-between px-4 py-2 text-primary truncate sm:text-base border-2 rounded-full transition duration-150 ease-in",
          onClick: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (_ctx.confirmationModal.tell(false)), ["prevent"]))
        }, " Cancel "),
        _createElementVNode("button", {
          class: "btn-filled-sm flex flex-row items-center disabled:opacity-50 justify-between truncate sm:text-base bg-primary rounded-full transition duration-150 ease-in",
          onClick: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (_ctx.confirmationModal.tell(true)), ["prevent"]))
        }, " Add skills ")
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}